import React from "react";
import i18n from "../../i18n";

export default function CrossDockEmptyContent() {
    return (
        <div className="empty-delivery">
            <span className="empty-delivery__title">{i18n.t('Заявки отсутствуют')}</span>
        </div>
    );
}